import { ContactDto } from './auth/types'

export enum ProviderType {
  GOOGLE = 'google.com',
  FACEBOOK = 'facebook.com',
  APPLE = 'apple.com',
  PASSWORD = 'password'
}

export type AccountDto = {
  uuid: string
  firstName: string
  lastName: string
  nick: string | null
  newsletter: boolean
  email: string | null
  oAuthProvider: ProviderType
  demoEntries: number
  demo: boolean
  contact: ContactDto
  packages: PackageDto[]
}

export type PackageDto = {
  uuid: string
  totalEntries: number
  leftEntries: number
  validUntil: string
  places: PackagePlaceDto[]
}

export type PackagePlaceDto = {
  uuid: string
  name: string
}

export type UpdatePackageDto = Pick<AccountDto, 'demo' | 'packages' | 'demoEntries'>
